import { useEffect } from 'react';

export default function useFirstPromoter() {
  useEffect(() => {
    const numberOfDays = 60;
    const referralLinkTokenParam = 'fpr';
    const urlParams = new URLSearchParams(window.location.search);
    const referralLinkToken = urlParams.get(referralLinkTokenParam.replace('?', ''));

    if (referralLinkToken) {
      document.cookie = `_fprom_ref=${referralLinkToken}; path=/; max-age=${numberOfDays * 24 * 60 * 60}`;
    }
  }, []);
}
